import React from 'react'
import { Card } from 'react-bootstrap'
import { Scale, ArrowRight, Shield, FileCheck, Users } from 'lucide-react'
import './LegalAsServiceBanner.css'

const LegalAsServiceBanner = () => {

  return (
    <Card className="legal-service-banner-card">
      <div className="legal-service-banner-content">
        <div className="legal-service-banner-main">
          <div className="legal-service-banner-header">
            <div className="legal-service-banner-icon-wrapper">
              <Scale className="legal-service-banner-icon" />
            </div>
            <div className="legal-service-banner-title-section">
              <div className="legal-service-banner-title-row">
                <h3 className="legal-service-banner-title">Legal as a Service</h3>
                <span className="legal-service-banner-badge">Bonuz</span>
              </div>
              <p className="legal-service-banner-subtitle">
                Suporte jurídico completo para o dia a dia da sua empresa
              </p>
            </div>
          </div>

          <p className="legal-service-banner-description">
            Tenha acesso a uma equipe jurídica especializada para atender todas as demandas 
            do seu negócio. Contratos, consultorias, compliance e muito mais.
          </p>

          <div className="legal-service-banner-features">
            <div className="legal-service-banner-feature">
              <FileCheck className="legal-service-banner-feature-icon" />
              <span className="legal-service-banner-feature-text">Revisão e elaboração de contratos</span>
            </div>
            <div className="legal-service-banner-feature">
              <Shield className="legal-service-banner-feature-icon" />
              <span className="legal-service-banner-feature-text">Consultoria jurídica ilimitada</span>
            </div>
            <div className="legal-service-banner-feature">
              <Users className="legal-service-banner-feature-icon" />
              <span className="legal-service-banner-feature-text">Equipe dedicada para sua empresa</span>
            </div>
          </div>

          <button 
            className="legal-service-banner-button"
            onClick={() => window.open('https://inst.bonuz.it/', '_blank')}
          >
            <Scale className="legal-service-banner-button-icon" />
            Conhecer planos jurídicos
            <ArrowRight className="legal-service-banner-button-icon" />
          </button>
        </div>

        <div className="legal-service-banner-decoration">
          <div className="legal-service-banner-decoration-glow"></div>
          <Scale className="legal-service-banner-decoration-icon" />
        </div>
      </div>
    </Card>
  )
}

export default LegalAsServiceBanner
